import { Editor } from '@tiptap/react';

/**
 * Editor action utilities for TipTap editor operations
 */
export class EditorActions {
    constructor(private editor: Editor | null) {}

    // Text formatting actions
    toggleBold = () => {
        this.editor?.chain().focus().toggleBold().run();
    };

    toggleItalic = () => {
        this.editor?.chain().focus().toggleItalic().run();
    };

    toggleStrike = () => {
        this.editor?.chain().focus().toggleStrike().run();
    };

    toggleHeading = (level: 1 | 2 | 3 | 4 | 5 | 6 = 3) => {
        this.editor?.chain().focus().toggleHeading({ level }).run();
    };

    toggleBulletList = () => {
        this.editor?.chain().focus().toggleBulletList().run();
    };

    // Content insertion actions
    insertImage = (src: string) => {
        this.editor?.chain().focus().insertContent(`<img src="${src}" />`).run();
    };

    setContent = (content: string) => {
        this.editor?.chain().focus().setContent(content).run();
    };

    focus = () => {
        this.editor?.chain().focus().run();
    };

    insertVariableItem = (id: string, name: string) => {
        this.editor
            ?.chain()
            .focus()
            .insertContent([
                {
                    type: 'variableItem',
                    attrs: {
                        id,
                        name,
                    },
                },
                {
                    type: 'text',
                    text: ' ',
                },
            ])
            .run();
    };
    insertIframe = (src: string) => {
        this.editor
            ?.chain()
            .focus()
            .insertContent(
                `<iframe style="width:100%; height:100%; border:0; aspect-ratio:1.65;overflow:hidden;" scrolling="no" src="${src}"></iframe>`
            )
            .run();
    };
}
